import { render } from "./ViewSourceFile.vue?vue&type=template&id=af08799c&scoped=true"
import script from "./ViewSourceFile.vue?vue&type=script&lang=js"
export * from "./ViewSourceFile.vue?vue&type=script&lang=js"

import "./ViewSourceFile.vue?vue&type=style&index=0&id=af08799c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af08799c"]])

export default __exports__